import React from 'react';
import ValidationControlPanelPage from './ValidationControlPanelPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import helper from '../../../../utils/helper';

class ValidationControlPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowIndex: null,
      groups: [],
      groupId: null,
      validationCP: [],
      loading: false,
      isFetching: false,
      errors: '',
      openModal: false,
      selectedRow: null,
      intervalId: null,
      selectedValue: null,
    };
    this.defaultSorted = [
      {
        dataField: 'location',
        order: 'asc',
      },
    ];
    this.refreshRate = helper.getSetting('ValueRefreshRateSec');
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {
      errors: prevState.errors,
    };
    if (nextProps.configure.groups !== prevState.groups) {
      state.groups = nextProps.configure.groups;
    }
    if (nextProps.configure.validationCP !== prevState.validationCP) {
      state.validationCP = nextProps.configure.validationCP;
    }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    if (nextProps.configure.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.configure.isFetching;
    }
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    await this.props.getGroups();
  }
  onChangeGroup = (groupId) => {
    this.setState({ groupId }, async () => {
      await this.props.getVCP(groupId);
      if (this.state.intervalId) {
        clearInterval(this.state.intervalId);
      }
      const intervalId = setInterval(async () => {
        await this.props.getVCP(groupId);
      }, parseInt(this.refreshRate.value) * 1000);
      this.setState({ intervalId });
    });
  };
  onOverride = async (value, row) => {
    await this.props
      .overrideVCP(row.sensorId, {
        sensorSerial: row.name,
        value,
      })
      .then(async () => await this.props.getVCP(this.state.groupId));
  };
  onNormal = async (value, row) => {
    await this.props
      .normalVCP(row.sensorId, {
        sensorSerial: row.name,
        value,
      })
      .then(async () => await this.props.getVCP(this.state.groupId));
  };
  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <ValidationControlPanelPage
        {...this.state}
        onChangeGroup={this.onChangeGroup}
        onOverride={this.onOverride}
        onNormal={this.onNormal}
        defaultSorted={this.defaultSorted}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}
export default connect(
  mapStateToProps,
  configureActions,
)(ValidationControlPanel);
